<template>
  <div class="container">
    <div class="w1200">
      <nav>
        当前位置：
        <a v-if="type == 'article'" @click="toArticle">首页 > </a>
        <a v-else @click="toHome">期刊 > </a>
        高级检索
      </nav>
      <div class="wapper">
        <div class="main">
          <div class="item flex" v-for="(item, index) in type == 'article' ? list : homeItemList" :key="index">
            <el-select v-model="item.searchField" placeholder="请选择">
              <el-option v-for="item in type == 'article' ? articleList : homeList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <el-input placeholder="请输入关键词" v-if="item.searchField != 'journal' && item.searchField != 'subject'" v-model="item.searchWords" clearable></el-input>
            <el-select class="selectVal" v-if="item.searchField == 'journal'" v-model="item.searchWords" filterable clearable placeholder="请选择期刊">
              <el-option v-for="item in journalList" :key="item.sid" :label="item.name" :value="item.sid + '+' + item.name"> </el-option>
            </el-select>
            <el-select class="selectVal" clearable v-if="item.searchField == 'subject'" v-model="item.searchWords" placeholder="请选择学科">
              <el-option v-for="item in subjcetList" :key="item.id" :label="item.subjectName" :value="item.id + '+' + item.subjectName"> </el-option>
            </el-select>
            <el-select class="opera" v-if="index != 0" v-model="item.operation" placeholder="请选择">
              <el-option v-for="item in operationList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
            <div class="icons flex">
              <i class="el-icon-plus" v-if="index !== 0" @click="add(index)"></i>
              <i class="el-icon-minus" v-if="index > 1" @click="remove(index)"></i>
            </div>
          </div>
          <el-button type="primary" @click="toSearch">检索</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import urlSet from "@/api/baseurl.js";
export default {
  data() {
    return {
      articleList: [
        {
          value: "title",
          label: "题名",
        },
        {
          value: "doi",
          label: "DOI",
        },
        {
          value: "author",
          label: "作者",
        },
        {
          value: "journal",
          label: "期刊",
        },
        {
          value: "subject",
          label: "学科",
        },
      ],
      homeList: [
        {
          value: "name",
          label: "刊名",
        },
        {
          value: "issn",
          label: "ISSN",
        },
        {
          value: "publisherName",
          label: "出版社",
        },
      ],
      operationList: [
        {
          value: "1",
          label: "与",
        },
        {
          value: "2",
          label: "或",
        },
      ],
      list: [
        {
          searchField: "title",
          searchWords: "",
          operation: "1",
        },
        {
          searchField: "doi",
          searchWords: "",
          operation: "1",
        },
        {
          searchField: "author",
          searchWords: "",
          operation: "1",
        },
        {
          searchField: "journal",
          searchWords: "",
          operation: "1",
        },
        {
          searchField: "subject",
          searchWords: "",
          operation: "1",
        },
      ],
      homeItemList: [
        {
          searchField: "name",
          searchWords: "",
          operation: "1",
        },

        {
          searchField: "issn",
          searchWords: "",
          operation: "1",
        },
        {
          searchField: "publisherName",
          searchWords: "",
          operation: "1",
        },
      ],
      type: "",
      journalList: [],
      subjcetList: [],
    };
  },
  mounted() {
    this.type = this.$route.query.type;
    this.getJournalTitle();
    this.getSubjectData();
  },
  methods: {
    getSubjectData() {
      this.$http({
        url: `api/v1/reception/journal/subjectData`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.subjcetList = res.data;
        }
      });
    },
    getJournalTitle() {
      this.$http({
        url: `api/v1/reception/journal/journalTitle`,
        method: "GET",
      }).then(res => {
        if (res.code == 200) {
          this.journalList = res.data;
        }
      });
    },
    add() {
      if (this.type == "article") {
        this.list.push({
          searchField: "title",
          searchWords: "",
          operation: "1",
        });
      } else {
        this.homeItemList.push({
          searchField: "name",
          searchWords: "",
          operation: "1",
        });
      }
    },
    remove(index) {
      if (this.type == "article") {
        this.list.splice(index, 1);
      } else {
        this.homeItemList.splice(index, 1);
      }
    },
    toSearch() {
      let array = [];
      if (this.type == "article") {
        this.list.forEach(element => {
          if (element.searchWords) {
            array.push(element);
          }
        });
        array.forEach((element, index) => {
          if (element.searchWords.includes("+")) {
            array[index].searchVal = element.searchWords.split("+")[0];
            array[index].searchLabel = element.searchWords.split("+")[1];
          }
        });
        sessionStorage.setItem("heightSearchWord", JSON.stringify(array));
        // return;
        if (array.length > 0) {
          this.$router.push({ path: "/article" });
        } else {
          this.$message.error("请输入关键词,进行检索!");
        }
      } else {
        this.homeItemList.forEach(element => {
          if (element.searchWords) {
            array.push(element);
          }
        });
        sessionStorage.setItem("heightSearchWord", JSON.stringify(array));
        this.$router.push({ path: "/home" });
      }
    },
    toArticle() {
      this.$router.push({ path: "/article" });
    },
    toHome() {
      this.$router.push({ path: "/home" });
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  min-width: calc(100vw);
  min-height: calc(100vh - 160px);
  nav {
    padding: 20px 0;
    font-size: 14px;
    color: #999999;
  }
  .wapper {
    background: #fff;
    display: flex;
    justify-content: center;
    padding-top: 100px;
    min-height: calc(100vh - 240px);
    padding-bottom: 30px;
    margin-bottom: 30px;
    .item {
      align-items: center;
      margin-bottom: 20px;
      .el-select {
        margin-right: 10px;
        width: 120px;
      }
      ::v-deep .el-input__inner {
        border-radius: 0;
      }
      .opera {
        width: 100px;
      }
      .el-input,
      .selectVal {
        width: 400px;
        margin-right: 10px;
      }
      .icons {
        margin-left: 10px;
        i {
          margin: 0 10px;
          cursor: pointer;
          background: #2d8cf0;
          color: #fff;
          padding: 3px;
          color: #fff;
        }
      }
    }
    .el-button {
      width: 120px;
      border-radius: 0;
    }
  }
}
</style>
